import { render, staticRenderFns } from "./relatedOrder.vue?vue&type=template&id=45648caf&scoped=true"
import script from "./relatedOrder.vue?vue&type=script&lang=js"
export * from "./relatedOrder.vue?vue&type=script&lang=js"
import style0 from "./relatedOrder.vue?vue&type=style&index=0&id=45648caf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45648caf",
  null
  
)

export default component.exports